import { useState } from 'react'
import { Link } from 'react-router-dom'

function Card({data, hideButton}) {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className='cardd flex flex-col m-3 mb-5 shadow-medium rounded-2xl overflow-hidden hover:shadow-strong hover:-translate-y-2 transition-all duration-300 bg-white border border-gray-100 animate-scale-in group' style={{width: '280px'}}>
        <div className="w-full h-52 overflow-hidden relative bg-gray-100">
            {imageError || !data.image_url ? (
              <div className='w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200'>
                <div className='text-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto mb-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <p className='text-gray-500 text-sm font-medium'>No Image</p>
                </div>
              </div>
            ) : (
              <img
                className='w-full h-full object-cover group-hover:scale-110 transition-transform duration-500'
                loading='eager'
                src={data.image_url}
                alt={data.name}
                onError={handleImageError}
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>
        <div className="flex flex-col text-dark-600 py-4 px-4">
            <h3 className='font-bold text-lg text-dark-800 mb-1'>{data.name}</h3>
            {
              hideButton ? (
                <div className='flex items-center gap-2 text-primary-600'>
                  <i className="fa fa-check-circle"></i>
                  <small className='font-semibold'>34 Votes</small>
                </div>
              ) : (
                <small className='text-dark-500 flex items-center gap-2'>
                  <i className="fa fa-calendar text-primary-500"></i>
                  2025
                </small>
              )
            }
        </div>
        {
          hideButton ? '' : (
            <Link to={`/awards/${data.id}`} className='w-full'>
              <button className='w-full text-white text-center font-semibold rounded-b-2xl py-3 bg-gradient-primary hover:shadow-glow transition-all duration-300 transform hover:scale-[1.02]'>
                Select Event
              </button>
            </Link>
          )
        }
    </div>
  )
}

export default Card